import TextContentBlock from "@/components/content-block/text/index";
import UnorderedListContentBlock from "@/components/content-block/unordered-list/index";
import DownloadBlock from "@/components/content-block/download/index";

export default {
  components: {
    TextContentBlock,
    UnorderedListContentBlock,
    DownloadBlock,
  },
  props: {
    content: { type: Object, required: true },
  },
  computed: {
    supported_by_locale() {
      return (
        this.content.supported_locales === undefined ||
        this.$i18n.locale in this.content.supported_locales
      );
    },
  },
};
